function delay(ms = 1000) {
	return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function timeout(fn) {
	await delay()
	return fn()
}
